<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"/>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"/>
    <!-- <router-view v-if="isRouterAlive"/> -->

    <!-- <div style="height: 50px"></div> -->
  </div>
</template>

<script>
import { PageHelper } from "./PageHelper";
import { HttpHelper } from "./HttpHelper";
import Config from "./Config";
import Vue from "vue";
import { Popup } from "vant";

export default {
  name: "App",
  provide(){
    return {
      reload:this.reload
    }
  },
  data() {
    return {
      Res: {},
      show: false,
      all: false,
      right: "A",
      inwechat: false,
      uploadpath: null,
      token:"",
      hideRecharge: false,
      isRouterAlive: true
    };
  },
  created() {
    let token = window.localStorage.getItem("token");
    this.token=token;
    console.log(token);
    PageHelper.setTitle("掰投");
    // this.inwechat=PageHelper.InWechat;

    let viewer = window.navigator.userAgent.toLowerCase();
    if (viewer.match(/MicroMessenger/i) == "micromessenger") {
      this.inwechat = true;
    }

    HttpHelper.Post("inst/resources", {}).then((res) => {
      this.Res = res;
      this.uploadpath = Config.UploadPath;
    });
  },
  updated() {
    let path = this.$route.path;
    if (path == "/freerent") {
      this.hideRecharge = true;
    } else {
      this.hideRecharge = false;
    }
  },
  methods: {
    routeto(name) {
      this.$router.push({ path: "/" + name });
      this.closePopup();
    },
    showall() {
      if (this.all == false) {
        this.all = true;
      } else {
        this.all = false;
      }
    },
    showPopup() {
      this.show = true;
    },
    closePopup() {
      this.show = false;
    },
    showright(type) {
      this.right = type;
    },
    reload(){
      this.isRouterAlive = false
      this.$nextTick(function(){
        this.isRouterAlive = true
      })
    }
  },
};
</script>

<style>
.top {
  position: fixed;
  z-index: 10;
  width: 96%;
  top: 0;
  background: white;
}
.margin-left-34 {
  margin-left: 34px;
}
.dian {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #000000;
}
.more {
  width: 24px;
  height: 24px;
}
.logo2 {
  width: 105px;
  height: 28px;
}
.close {
  width: 18px;
  height: 18px;
}
.mid_block {
  margin-left: 20px;
  padding: 10px 10px 10px 0;
  border-bottom: 1px solid #f0f0f0;
}
/* .right_block {
  position: fixed;
  width: 100vw; 
  z-index: 20;
  top: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
} */
/* .white_block {
  background: rgb(255, 255, 255);
  width: 70%;
  height: 100vh;
} */
.opa7 {
  opacity: 0.7;
}
.opa5 {
  opacity: 0.5;
}
.tiao {
  width: 69px;
  height: 4px;
  background: linear-gradient(270deg, rgba(255, 255, 255, 0) 0%, #6f97ff 100%);
  border-radius: 2px;
}
.logo {
  height: 18px;
}
div {
}
.container {
  min-width: 940px;
  max-width: 940px;
}

.flex-row {
  display: flex;
}
.display-none{
  display: none;
}

.flex-wrap {
  flex-wrap: wrap;
}

.flex-center {
  align-content: center;
  align-items: center;
}

.flex-column {
  align-content: center;
  align-items: center;
  flex-direction: column;
}

.flex-bottom {
  align-content: flex-end;
  align-items: flex-end;
}

.justify-between {
  display: flex;
  justify-content: space-between;
}
.justify-center {
  display: flex;
  justify-content: center;
}

.justify-content {
  display: flex;
  justify-content: left;
}
.hnys{
  flex-wrap: wrap;
  display: inline-block;
}

.flex-1 {
  flex: 1;
}
.flex-2 {
  flex: 2;
}
.flex-3 {
  flex: 3;
}
.text-center {
  text-align: center;
}

.text-right {
  text-align: right;
}

.margin-1x {
  margin: 10px;
}
.margin {
  margin: 20px;
}
.margin-15 {
  margin: 15px;
}
.margin-3x {
  margin: 30px;
}
.margin-4x {
  margin: 40px;
}
.margin-7x {
  margin: 70px;
}
.margin-top-04x {
  margin-top: 4px;
}
.margin-bottom-04x {
  margin-bottom: 4px;
}

.margin-top-05x {
  margin-top: 10px;
}
.margin-top-06x {
  margin-top: 6px;
}
.margin-top-1x {
  margin-top: 10px;
}
.margin-top-15 {
  margin-top: 15px;
}
.margin-top {
  margin-top: 20px;
}
.margin-top-3x {
  margin-top: 30px;
}
.margin-top-4x {
  margin-top: 40px;
}
.margin-top-5x {
  margin-top: 50px;
}
.margin-top-6x {
  margin-top: 60px;
}
.margin-top-8x {
  margin-top: 80px;
}
.margin-top-10x {
  margin-top: 100px;
}
.margin-top-12x {
  margin-top: 120px;
}
.margin-top-20x {
  margin-top: 200px;
}
.margin-left-06x {
  margin-left: 6px;
}
.margin-left-1x {
  margin-left: 10px;
}
.margin-left {
  margin-left: 20px;
}
.margin-left-3x {
  margin-left: 30px;
}
.margin-left-4x {
  margin-left: 40px;
}
.margin-left-5x {
  margin-left: 50px;
}
.margin-left-6x {
  margin-left: 60px;
}
.margin-left-7x {
  margin-left: 70px;
}
.margin-left-8x {
  margin-left: 80px;
}
.margin-left-9x {
  margin-left: 90px;
}
.margin-left-95x {
  margin-left: 95px;
}
.margin-left-10x {
  margin-left: 100px;
}
.margin-left-22x {
  margin-left: 220px;
}
.margin-left-24x {
  margin-left: 240px;
}
.margin-left-26x {
  margin-left: 260px;
}
.margin-right-06x {
  margin-right: 6px;
}
.margin-right-1x {
  margin-right: 10px;
}
.margin-right {
  margin-right: 20px;
}
.margin-right-3x {
  margin-right: 30px;
}
.margin-right-4x {
  margin-right: 40px;
}
.margin-right-5x {
  margin-right: 50px;
}
.margin-right-6x {
  margin-right: 60px;
}
.margin-right-7x {
  margin-right: 70px;
}
.margin-right-95x {
  margin-right: 95px;
}

.margin-bottom-1x {
  margin-bottom: 10px;
}
.margin-bottom {
  margin-bottom: 20px;
}
.margin-bottom-3x {
  margin-bottom: 30px;
}
.margin-bottom-4x {
  margin-bottom: 40px;
}

.padding-1x {
  padding: 10px;
}
.margin-1x {
  margin: 10px;
}
.padding-1_5x {
  padding: 14px;
}
.padding {
  padding: 20px;
}
.padding-tb {
  padding: 10px 0 10px 0;
}

.padding-3x {
  padding: 30px;
}
.padding-4x {
  padding: 40px;
}

.padding-top-1x {
  padding-top: 10px;
}
.padding-top {
  padding-top: 20px;
}
.padding-top-3x {
  padding-top: 30px;
}
.padding-top-4x {
  padding-top: 40px;
}
.padding-top-6x {
  padding-top: 60px;
}
.padding-left-05x {
  padding-left: 5px;
}
.padding-right-05x {
  padding-right: 5px;
}
.padding-left-1x {
  padding-left: 10px;
}
.padding-left {
  padding-left: 20px;
}
.padding-left-3x {
  padding-left: 30px;
}
.padding-left-4x {
  padding-left: 40px;
}

.padding-right-1x {
  padding-right: 10px;
}
.padding-right {
  padding-right: 20px;
}
.padding-right-3x {
  padding-right: 30px;
}
.padding-right-4x {
  padding-right: 40px;
}

.padding-bottom-1x {
  padding-bottom: 10px;
}
.padding-bottom {
  padding-bottom: 20px;
}
.padding-bottom-3x {
  padding-bottom: 30px;
}
.padding-bottom-4x {
  padding-bottom: 40px;
}
.padding-pbm {
  padding: 14px 0 14px 0;
}
.padding-1020 {
  padding: 20px 10px 20px 10px;
}
.margin-pbm {
  margin: 0 20px 0 20px;
}
.margin-nob {
  margin: 0 20px 20px 20px;
}

.margin-p {
  margin: 14px 20px 14px 20px;
}
.border-1x {
  border-radius: 4px;
}
.border {
  border-radius: 8px;
}
.border-3x {
  border-radius: 12px;
}
.border-top{
  border-radius: 20px 20px 0 0;
}
.border-under{
  border-radius: 0 0 20px 20px;
}
.border-4x {
  border-radius: 16px;
}
.border-5x {
  border-radius: 20px;
}
.border-10x {
  border-radius: 40px;
}
.border-6x {
  border-radius: 50px;
}
.border-44x {
  border-radius: 44px;
}
.border-25x {
  border-radius: 25px;
}
.border-50 {
  border-radius: 50%;
}
.fix-top {
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100vw;
  z-index: 1000;
}
.fix-middle {
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100vw;
  height: 100vh;
  display: flex;
  align-content: center;
  align-items: center;
}
.fix-bottom {
  position: fixed;
  bottom: 0px;
  left: 0px;
  width: 100vw;
}
.w-100 {
  width: 100%;
}
.h-88{
  height: 88px;
  line-height: 88px;
}
.h-100 {
  height: 100%;
}
.h-200 {
  height: 200px;
}
.h-68 {
  height: 67.5%;
}
.h-140 {
  height: 140px;
}
.h-80 {
  height: 80px;
}
.h-85 {
  height: 85px;
}
.h-51 {
  height: 51px;
}
.h-60{
  height: 60px;
}
.bold {
  font-weight: bold;
}
.bold-5 {
  font-weight: 500;
}
.bolder {
  font-weight: bolder;
}
.mid {
  font-weight: normal;
}
.h1 {
  font-size: 44px;
}
.h2 {
  font-size: 28px;
}
.h3 {
  font-size: 22px;
}
.h4 {
  font-size: 18px;
}
.f16 {
  font-size: 16px;
  line-height: 16px;
}
.h5 {
  font-size: 15px;
}
.h6 {
  font-size: 14px;
}
.h7 {
  font-size: 12px;
}
.h8 {
  font-size: 10px;
}
.h9 {
  font-size: 8px !important;
}
.f-13 {
  font-size: 13px;
}
.f-11 {
  font-size: 11px;
}
.f-20 {
  font-size: 20px;
}
.f-24 {
  font-size: 24px;
}
.f-32 {
  font-size: 32px;
}
.f-36 {
  font-size: 36px;
}
.f-40 {
  font-size: 40px;
}
.f-48 {
  font-size: 48px;
}
.f-60 {
  font-size: 60px;
}
.dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #090909;
}
.split {
  height: 12px;
  width: 1px;
  background: #090909;
}
.pointer {
  cursor: pointer;
}
.under {
  position: fixed;
  width: 100%;
  z-index: 10;
  bottom: 5%;
}
.icon-05x {
  width: 15px;
  height: 15px;
}
.icon-1x {
  width: 24px;
  height: 24px;
}
.icon {
  width: 48px;
  height: 48px;
}
.icon-2x {
  width: 64px;
  height: 64px;
}
.icon-3x {
  width: 72px;
  height: 72px;
}
.icon-4x {
  width: 96px;
  height: 96px;
}
.icon-5x {
  width: 120px;
  height: 120px;
}
.icon-6x {
  width: 80px;
  height: 80px;
}
.icon-7x {
  width: 100px;
  height: 100px;
}
.icon-8x {
  width: 300px;
  height: 300px;
}
.icon-9x {
  width: 44px;
  height: 44px;
}
.icon-10x {
  width: 24px;
  height: 24px;
}
.icon-11x {
  width: 160px;
  height: 160px;
}
.icon-12x {
  width: 52px;
  height: 52px;
}
.icon-13x {
  width: 28px;
  height: 28px;
}
.icon-14x {
  width: 34px;
  height: 34px;
}
.icon-15x {
  width: 330px;
  height: 330px;
}

.color-w {
  color: #ffffff;
}

.bg-r {
  background: #F95651;
}
.bg-r1 {
  background: #FE3837;
}
.bg-w {
  background: #ffffff;
}
.bg-g {
  background: #f0f0f0;
}
.bg-g2 {
  background: #f5f7fa;
}
.bg-g3 {
  background: #f0f2f5;
}
.bg-g4 {
  background: #E4E4E4;
}
.bg-g5 {
  background: #588BF9;
}
.bg-g6 {
  background: #C2D4FF;
}
.bg-g7 {
  background: #999999;
}
.bg-g8 {
  background: #EFF6FF;
}
.bg-g9 {
  background: #9D9B2A;
}
.bg-g10 {
  background: #F6F6F6;
}
.bg-g11 {
  background: #B1AE58;
}
.bg-g12 {
  background: #FFF5D6;
}
.bg-g13 {
  background: #FAFAFA;
}
.bg-g14 {
  background: #9C9E21;
}
.bg-g15 {
  background: #3358FB;
}
.bg-g16{
  background: #A19A2A;
}
.f-w {
  color: white;
}
.f-d {
  color: #df4747;
}
.f-d1 {
  color: #F64E54;
}
.f-warn {
  color: #faab0c;
}
.f-warn1 {
  color: #EC724D;
}
.f-s {
  color: #07c160;
}
.f-s1 {
  color: #9D9B2A;
}
.f-s2 {
  color: #9C9E21;
}
.f-p {
  color: #284ca2;
}
.f-p2 {
  color: #588BF9;
}
.f-g {
  color: #c3c3c3;
}
.f-g2 {
  color: #819199;
}
.f-g3 {
  color: #999999;
}
.f-g4 {
  color: #666666;
}
.f-b {
  color: #000000;
}
.f-b2 {
  color: #333333;
}
.f-w.el-link {
  color: white !important;
}
.bg-trans {
  background: transparent;
}
.height-05x {
  height: 50px;
}
.width-05x {
  width: 50px;
}
.width-1x {
  width: 100px;
}
.width-15x {
  width: 150px !important;
}
.width {
  width: 200px;
}
.width-25x {
  width: 250px;
}
.width-3x {
  width: 300px;
}
.width-4x {
  width: 400px;
}
.width-5x {
  width: 550px;
}
.width-6x {
  width: 610px;
}
.width-690 {
  width: 690px;
}
.width-330 {
  width: 330px;
}
.height-1 {
  height: 1px;
}
.height-10 {
  height: 10px;
}
.height-20 {
  height: 20px;
}
.height-60 {
  height: 60px;
}
.height-80 {
  height: 80px;
}
.height-160 {
  height: 160px;
}
.height-1x {
  height: 100px;
}
.height {
  height: 200px;
}
.height-3x {
  height: 300px;
}
.height-4x {
  height: 400px;
}
.height-450 {
  height: 450px;
}
.margin-zy15 {
  margin: 0 15px;
}

.bg-p {
  background: #409eff;
}
.bd {
  border: 1px solid #d7dae2;
}
.bd1 {
  border: 1px solid #CDCDCD;
}
.bd-bottom {
  border-bottom: 1px solid #f0f0f0;
}
.bd-right {
  border-right: 1px solid #f0f2f5;
}
.border-tb {
  border-top: 1px solid #f0f0f0;
  border-bottom: 1px solid #f0f0f0;
}
.border-bottom2 {
  border-bottom: 1px solid #f2f2f2;
}
.border-none{
  border: none;
}
.scroll-x {
  overflow-x: scroll;
}
.scroll-y {
  overflow-y: auto;
}
.scroll {
  overflow: scroll;
}
.chaochu {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  
}
.chaochu1{
  height:40px;
  text-overflow:ellipsis;
overflow:hidden;
display:-webkit-box;
-webkit-line-clamp:2;	
-webkit-box-orient:vertical;
}
.van-card {
  background-color: white !important;
}

.cardbox {
  background: white;
  border-radius: 4px;
}

.right {
  width: 14px;
  height: 14px;
}

/* .btn {
  width: 100%;
  height: 46px;
  background: linear-gradient(73deg, #82b8ff 0%, #4b82ff 100%);
  border-radius: 24px;
  border: 0;
} */
.btn1 {
  width: 610px;
  height: 88px;
  background: #588BF9;
  border-radius: 44px;
  border: 0;
  color: #FFFFFF;
  font-size: 32px;
}
.btn2 {
  width: 690px;
  height: 88px;
  background: #588BF9;
  border-radius: 44px;
  border: 0;
  color: #FFFFFF;
  font-size: 32px;
}
.btn3 {
  height: 88px;
  background: #588BF9;
  border-radius: 44px;
  border: 0;
  color: #FFFFFF;
}
.van-toast {
  /* height: 200px; */
  width: 150px !important;
  /* font-size: 30px !important; */
}
/* .van-notify{
  font-size: 28px;
} */

.van-share-sheet__option {
  flex-direction: row !important;
  padding-bottom: 10px !important;
}
.van-share-sheet__options {
  padding: 30px 0 16px 8px !important;
  display: block !important;
}
.logo1 {
  width: 105px;
  height: 105px;
}
.wrap4 {
  width: 610px;
  height: 84px;
  line-height: 84px;
}
.guangbiao{
  height: 6px;
  width: 40px;
  background: #9C9E21;
  border-radius: 3px;
  margin: 0 auto;
}
.under2 {
  position: fixed;
  z-index: 10;
  bottom: 10%;
  right: 0;
}
.text-transform{
  text-transform:Uppercase;
}
</style>




// WEBPACK FOOTER //
// src/App.vue